package model

import ffMsgAviso
import utils.*
import utils.ff.Companion.println0

class Produto {
    var PRO_EMPRESA = 0
    var ID_PRODUTO = 0
    var PRO_QTEMB = 0
    var PRO_CXEMBARQUE = 0.0
    var PRO_USUALT = ""
    var PRO_DTALTCAD = ff.InicialDate
    var PRO_REFER = ""
    //  var PRO_IMG00 = ""

    var EST_CONTRLOTE = ""
    var EST_DIASVALID = 0
    var EST_DIASVALIDMIN = 0
    var EST_BARRAOFICIAL = ""
    var EST_SALDO = 0.0
    var EST_LOCAL00 = ""
    var ESTG_EAN = ""
    var ESTG_TIPO = ""
    var ESTG_UNIDVENDA = 0.0

    var PROLOT_ID = 0
    var PROLOT_LOTEFAB = ""
    var PROLOT_OBS = ""
    var PROLOT_QUARENTENA = ""

    var OO_DESCRCOMPLETA = ""

    /*
    fun construtor(EMPRESA: Int, PRODUTO: Int, QTEMB: Int, CXEMBARQUE: Double,
                   DESCRCOMPLETA: String, USUALT: String, DTALTCAD: Date,
                   CONTRLOTE: String, DIASVALID: Int, DIASVALIDMIN: Int,
                   BARRAOFICIAL: String, EAN: String, TIPO: String, UNIDVENDA: Double): Produto {
        this.PRO_EMPRESA = EMPRESA
        this.ID_PRODUTO = PRODUTO
        this.PRO_QTEMB = QTEMB
        this.PRO_CXEMBARQUE = CXEMBARQUE
        this.PRO_DESCRCOMPLETA = DESCRCOMPLETA
        this.PRO_USUALT = USUALT
        this.PRO_DTALTCAD = DTALTCAD
        this.EST_CONTRLOTE = CONTRLOTE
        this.EST_DIASVALID = DIASVALID
        this.EST_DIASVALIDMIN = DIASVALIDMIN
        this.EST_BARRAOFICIAL = BARRAOFICIAL
        this.ESTG_EAN = EAN
        this.ESTG_TIPO = TIPO
        this.ESTG_UNIDVENDA = UNIDVENDA
        return this
    }
    */

    fun construtorLista(_it: String): List<Produto> {

        val it = if (_it.ffCopy(1, 1).equals("[")) _it else "[$_it]"

        val lObj = ArrayList<Produto>()
        if ((!it.equals(null)) && (!it.equals(""))) {
            //val lista = JSON.parse<Array<Produto>>(it.responseText)
            val lista = JSON.parse<Array<dynamic>>(it)
            //println0("zuza123")
            //println0(lista)

            lista.forEach {
                val o = Produto()
                o.PRO_EMPRESA = it.PRO_EMPRESA.toString().ffVsi()
                o.ID_PRODUTO = it.ID_PRODUTO.toString().ffVsi()
                o.PRO_QTEMB = it.PRO_QTEMB.toString().ffVsi()
                o.PRO_CXEMBARQUE = it.PRO_CXEMBARQUE.toString().ffVsdo()
                o.PRO_USUALT = it.PRO_USUALT.toString().ffVss()
                o.PRO_DTALTCAD = it.PRO_DTALTCAD.toString().ffDsd()
                o.PRO_REFER = it.PRO_REFER.toString().ffVss()

                o.EST_CONTRLOTE = it.EST_CONTRLOTE.toString().ffVss()
                o.EST_DIASVALID = it.EST_DIASVALID.toString().ffVsi()
                o.EST_DIASVALIDMIN = it.EST_DIASVALIDMIN.toString().ffVsi()
                o.EST_BARRAOFICIAL = it.EST_BARRAOFICIAL.toString().ffVss()
                o.EST_SALDO = it.EST_SALDO.toString().ffVsdo()
                o.EST_LOCAL00 = it.EST_LOCAL00.toString().ffVss()
                o.ESTG_EAN = it.ESTG_EAN.toString().ffVss()
                o.ESTG_TIPO = it.ESTG_TIPO.toString().ffVss()
                o.ESTG_UNIDVENDA = it.ESTG_UNIDVENDA.toString().ffVsdo()

                o.PROLOT_ID = it.PROLOT_ID.toString().ffVsi()
                o.PROLOT_LOTEFAB = it.PROLOT_LOTEFAB.toString().ffVss()
                o.PROLOT_OBS = it.PROLOT_OBS.toString().ffVss()
                o.PROLOT_QUARENTENA = it.PROLOT_QUARENTENA.toString().ffVss()

                o.OO_DESCRCOMPLETA = it.OO_DESCRCOMPLETA.toString().ffVss()
                lObj.add(o)
            }
        }
        return lObj
    }

    fun consultarProduto(_produto: String, cb: (Produto) -> Unit) {
        var obj = Produto()
        Produto().getProduto(_produto) { lprod ->
            obj = lprod.get(0)
            cb(obj)
        }
    }

    fun getProduto(_recurso: String, cb: (List<Produto>) -> Unit) {
        Service().get(_recurso) { _sRetorno ->
            cb(Produto().construtorLista(_sRetorno.responseText))
        }
    }

    fun reg(_produto: Int, _eanTipo: String, lobj: List<Produto>): Produto {

        val obj2 = lobj.filter { p -> p.ID_PRODUTO == _produto }.filter { a -> a.ESTG_TIPO == _eanTipo }.getOrNull(0)
        if (obj2 != null)
            return obj2
        else
            return Produto()
    }

    fun verEan(_barras: String): String {
        //(01)08001250002792(10)82024101                    01080012500027921082024101              códigoGD=3041
        //(01)08076809073028(15)270201(10)13265584          0108076809073028152702011013265584      códigoGD=11242
        //(01)18001420118473(15)270120(10)200127            01180014201184731527012010200127
        //01-DUN14
        //11-FABRICACAO
        //15-VALIDADE
        //10-LOTE
        //17-PESO
        //21-NUMERO DE SERIE
        //BAR-Código de barras do produto - personalizado DLG
        /*
        //Tamanho 22 começando com 98 personalizado Dlógica
            **98 usado para a UC etiqueta do estoque
            **0000 número de série
            **000000 código do produto
            **000000000 id do lote
            **0
         */

        var sTeste = _barras
        if (_barras.length > 14) {
            sTeste = decodificarCodigoBarras(_barras).get("gtin").toString()
        }
        return sTeste
    }

    fun decodificarCodigoBarras(codigo: String): Map<String, String> {

        val decodificado = mutableMapOf<String, String>()

        // Verifica se o código é válido
        if (codigo.length < 14 || codigo.length > 34) {
            decodificado["erro"] = "Código inválido"
            return decodificado
        }

        var indice = 0

        while (indice < codigo.length) {
            val tipoDados = codigo.ffSubstring(indice, indice + 2)
            val comprimentoDados = when (tipoDados) {
                "01" -> 14 // GTIN
                "10" -> 8 // Lote
                "11" -> 6 // Data de fabricação
                "15" -> 6 // Data de validade
                "17" -> 6 // Peso
                "21" -> 6 // Número de série
                else -> 0
            }

            if (comprimentoDados > 0) {
                val dados = codigo.ffSubstring(indice + 2, indice + 2 + comprimentoDados)
                when (tipoDados) {
                    "01" -> decodificado["gtin"] = dados
                    "10" -> decodificado["lote"] = dados
                    "11" -> decodificado["dataFabricacao"] = dados.ffDssEan()
                    "15" -> decodificado["dataValidade"] = dados.ffDssEan()
                    "17" -> decodificado["peso"] = dados
                    "21" -> decodificado["numeroSerie"] = dados
                }
                indice += 2 + comprimentoDados
            } else {
                decodificado["erro"] = "Tipo de dados desconhecido"
                break
            }
        }

        return decodificado
    }

    fun consultarProduto(_produto: String, bMantemCx: Boolean = false, cb: (List<Produto>?) -> Unit) {

        println0("@investigar consultarProduto")
        if (_produto.equals("")) {
            ffMsgAviso("Informe o produto")
        } else {
            val produto = verEan(_produto)
            println0("888 - verEan $produto")
            getProduto("produto/017/${ff.giEmpresa}/${produto}") { lista ->

                val obj = lista.getOrNull(0)
                if (obj == null) {
                    ffMsgAviso("Produto não encontrado")
                } else if (obj.PROLOT_QUARENTENA == "S") {
                    ffMsgAviso("Produto foi colocado em quarentena ${obj.ID_PRODUTO}, a OF necessita ser cancelada para ser gerada uma nova separação")
                } else {
                    println0("Produto encontrado $produto")
                    cb(lista)
                }
            }
        }
    }

}